import { Component, HostListener } from '@angular/core';
import { NiceSdkAuthenticationService } from '../../data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { SdkDigitalService } from '../../data/CXOne/sdk-digital/sdk-digital.service';
import { SdkAcdAgent } from '../../data/CXOne/sdk-acd/sdk-acd.service';
import { LoggerService } from '../../core/services/logger.service';
import { CXoneAuth } from '@nice-devone/auth-sdk';
import { LoginService } from '../../core/services/login.service';
import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { AgentSettings } from '@nice-devone/core-sdk';
import {
  AgentSessionStatus,
  CXonePopUrl,
  UserInfo,
} from '@nice-devone/common-sdk';
import { CXoneAcdClient, CXoneVoiceContact } from '@nice-devone/acd-sdk';
import {
  DynamicsCivicsService,
  TemplateValuesChannelProvider,
} from '../../data/Dynamics/civics/dynamics-civics.service';
import { environment } from 'src/environments/environment';
import { CXoneDigitalContact } from '@nice-devone/digital-sdk';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { SendReloadScreenSignalService } from 'src/app/shared/services/sendReloadScreenSignalService';
import { CxOneUtils } from 'src/app/data/CXOne/util/CxOneUtils';
import {
  ContactCenterMainService,
  TemplateValuesChannelProviders,
} from 'src/app/data/CXOne/services/main/contact-center-main.service';
import { TicketCreationRequestControlService } from 'src/app/shared/services/ticket-creation-request-control.service';
import { CIFDatadogService } from 'src/app/shared/services/cif-datadog';
import { MediaType } from 'src/app/utils/media-type';
import { getMediaType } from 'src/app/utils/cxone-utils';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';

@Component({
  selector: 'app-civics',
  standalone: true,
  imports: [],
  templateUrl: './civics.component.html',
  styleUrl: './civics.component.css',
})
export class CivicsComponent {
  isTemplateReady: boolean = false;
  cxoneAuth: CXoneAuth;
  private channelProviderVariables: TemplateValuesChannelProvider | null = null;
  private channelProviderVariablesObj: TemplateValuesChannelProviders | null =
    null;
  private isReloadedSession = false;
  private pendingPopUrls = new Map<string, CXonePopUrl>();
  private activeSessionsIds: string[] = [];
  private sessionEnded: { contactId: string; templateAusente: string }[] = [];

  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private sdkDigital: SdkDigitalService,
    private logger: LoggerService,
    private loginService: LoginService,
    private dynamics: DynamicsCivicsService,
    private eventHandler: EventHandlerService,
    private sendReloadScreenSignalService: SendReloadScreenSignalService,
    private mainService: ContactCenterMainService,
    private ticketCreationRequestControlService: TicketCreationRequestControlService,
    private cifDatadogService: CIFDatadogService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
  ) {
    this.cxoneAuth = CXoneAuth.instance;
    this.isReloadedSession = sendReloadScreenSignalService.interactionIdExist();
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    this.sendReloadScreenSignalService.sendReloadSignal();
    event.preventDefault();
    event.returnValue = '';
  }

  async ngOnInit() {
    this.logger.info('CIVICS - inicializado');
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'civics';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );
      if (isAuthenticated) {
        this.logger.info('CIVICS - Usuario autenticado');
        await this.niceSdkAuthService.launchAgent();

        await this.sdkAcdAgent.initialize();
        await this.sdkDigital.initializeEvents();
        await this.dynamics.initialize(environment.cif_versao2_civics);

        this.channelProviderVariables =
          await this.dynamics.loadTemplateValues();

        this.logger.info(
          'CIVICS - Channel Provider Variables:',
          JSON.stringify(this.channelProviderVariables, null, 2),
        );

        if (!this.channelProviderVariables) {
          this.logger.error(
            'CIVICS - Erro ao carregar environment do CIFramework',
            JSON.stringify(this.channelProviderVariables, null, 2),
          );
        }

        /** ##### INCIO EVENTO DIGITAL CIVICS ##### **/
        this.sdkDigital.onDigitalContactEvent$.subscribe(
          async (digitalContact: CXoneDigitalContact) => {
            this.logger.info(
              `CIVICS - NICE Event Details: ${JSON.stringify(digitalContact.eventDetails)}`,
            );

            if (digitalContact.eventDetails.eventType === 'CaseInboxAssigned') {
              this.logger.info(
                'CIVICS - Evento digital recebido: ',
                JSON.stringify(digitalContact.case),
              );

              this.processDigitalCreateEvent(digitalContact);
            }

            if (
              digitalContact.eventDetails.eventType === 'CaseInboxUnassigned'
            ) {
              this.processDigitalEndedEvent(digitalContact);
            }
          },
        );

        this.sdkAcdAgent.instance.screenPop.screenPopSubscribe(
          true,
          true,
          true,
          true,
          true,
          true,
        );

        this.sdkAcdAgent.instance.screenPop.popUrlSubject.subscribe(
          async (popUrlData) => {
            this.DigitalAttachDataEventHandler(popUrlData);
          },
        );

        /** ##### FIM EVENTO DIGITAL CIVICS ##### **/

        this.logger.info(
          'DYNAMICS - terminando de adicionar Handler de session switch',
        );

        var input = {
          templateName: this.channelProviderVariables?.templateSessaoPadrao,
          templateParameters: {},
          context: {
            sessaobetta: true,
          },
        };

        // abre uma aba com a listagem de tickets associados a um usuário
        await this.dynamics.cifCreateSession(input, null, '');

        this.sdkAcdAgent.voiceContactUpdate$.subscribe(
          async (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            const skillName = voiceContact.skillName || '';
            const contact = voiceContact.isInbound ? 'INBOUND' : 'OUTBOUND';
            const callType = voiceContact.callType || '';
            const screenPopUrl = voiceContact.screenPopUrl || '';
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);
            const logStringAgent = `Contato: ${contact} | Status: ${status} | ContactID: ${contactId} | skillName: ${skillName} | callType: ${callType} | eventoProcessado: ${eventoProcessado} `;

            this.logger.info(
              `CIVICS (ACD - Evento Geral - ${logStringAgent}): `,
              voiceContact,
            );

            if (
              status === VoiceContactStatusAgent.ACTIVE &&
              !eventoProcessado
            ) {
              this.logger.info(
                `CIVICS (ACD - ${logStringAgent} | screenPopUrl: ${screenPopUrl}) | Iniciando atendimento.`,
              );

              this.eventHandler.add(contatoEvento);
              await this.processVoiceContactEvent(voiceContact, logStringAgent);
            }

            if (status === VoiceContactStatusAgent.DISCONNECTED) {
              this.eventHandler.remove(contatoEvento);
              const sessionId = this.localStorageUtils.safeGetItem(
                voiceContact.contactID,
              );

              if (!sessionId) {
                this.logger.info(
                  `CIVICS (ACD - ${logStringAgent}) | sessionId não encontrado no localStorage, não é possível encerrar: ${voiceContact.contactID}`,
                );
                return;
              }

              var context = {
                itau_cliente_on: false,
                itau_sessao_ativa: false,
              };

              this.logger.info(
                `CIVICS (ACD - ${logStringAgent}) - encerrando sessão: ${sessionId}`,
              );

              if (this.isReloadedSession === true) {
                this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
                this.isReloadedSession = false;
              } else {
                await this.dynamics
                  .cifCloseSession(
                    this.channelProviderVariables?.templateAusente ?? '',
                    context,
                    sessionId,
                    contactId,
                    getMediaType(voiceContact),
                  )
                  .finally(() => {
                    this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
                  });
              }

              this.logger.info(
                `CIVICS (ACD - ${logStringAgent}) - Contato desconectado ou transferido`,
              );

              this.localStorageUtils.safeRemoveItem(voiceContact.contactID);
              this.localStorageUtils.safeRemoveItem(sessionId);
            }
          },
        );

        CXoneAcdClient.instance.session.agentLegEvent.subscribe((data: any) => {
          CXoneVoiceClient.instance.handleAgentLegEvent(data);
          if (data.status === 'Dialing') {
            // CXoneVoiceClient.instance.triggerAutoAccept(data.agentLegId);
            CXoneVoiceClient.instance.connectAgentLeg(data.agentLegId);
          }
        });

        CXoneAcdClient.instance.session.onAgentSessionChange.subscribe(
          async (agentSessionChange) => {
            switch (agentSessionChange.status) {
              case AgentSessionStatus.JOIN_SESSION_SUCCESS:
              case AgentSessionStatus.SESSION_START: {
                this.logger.info('Agent session started successfully.....');
                // setStartSessionButton(true);
                await this.initWebRTC();
                break;
              }
              case AgentSessionStatus.SESSION_END: {
                this.logger.info('Agent session ended successfully.....');
                break;
              }
              case AgentSessionStatus.JOIN_SESSION_FAILURE:
                this.logger.info('Agent session join failed.....');
                break;
            }
          },
        );
      } else {
        this.logger.info('CIVICS - Usuario nao autenticado');
      }
    } catch (error) {
      this.logger.error('CIVICS - Erro ao autenticar usuario: ', error);
    }
  }

  private async processDigitalContactEvent(
    digitalContact: CXoneDigitalContact,
    popUrlData: CXonePopUrl,
  ): Promise<void> {}

  /** ##### MÉTODOS DE PROCESSAMENTO DO DIGITAL ##### **/
  private async DigitalAttachDataEventHandler(popUrl: CXonePopUrl) {
    this.logger.info('PopUrl recebido: ', popUrl);
    this.logger.info('tabTitle: ', popUrl.tabTitle?.toUpperCase());
    this.logger.info('contact ID: ', popUrl.contactId);

    if (popUrl.tabTitle?.toUpperCase() === 'ATTACHESDYNAMICS') {
      this.pendingPopUrls.set(popUrl.contactId, popUrl);
      this.logger.info(
        'Attachdata armazenado para contato digital: ',
        popUrl.contactId,
      );
    }

    if (popUrl.tabTitle?.toUpperCase() === 'FOCUS') {
      const dynamicsSessionData = this.localStorageUtils.safeGetItem(
        `sessionRelationship-${popUrl.contactId}`,
      );

      if (dynamicsSessionData === null) return;

      let parsedData: {
        dynamicsSessionId: string;
        dynamicsinteractionId: string;
      } = {
        dynamicsSessionId: '',
        dynamicsinteractionId: '',
      };

      parsedData = this.jsonConverterUtils.JsonParsed(dynamicsSessionData);

      const sessionRelationship = parsedData;

      this.logger.info(
        'Solicitação de foco recebida: ',
        JSON.stringify(dynamicsSessionData),
      );

      this.logger.info(
        'Chamando raise event alterarSessao com os valores: ',
        sessionRelationship,
      );

      await (window as any).Microsoft.CIFramework.raiseEvent('alterarSessao', {
        sessionId: sessionRelationship.dynamicsSessionId,
        correlationId: sessionRelationship.dynamicsinteractionId,
      });
    }
  }

  private async processDigitalCreateEvent(digitalContact: CXoneDigitalContact) {
    try {
      let channel = '';
      let caseId = '';
      let popUrl: any = '';
      let isPopUrl = false;

      if (!digitalContact) {
        this.logger.error(
          'CIVICS - Evento principal digitalContact não recebido',
        );
        throw new Error('DIGITAL_CONTACT_NULL');
      }

      //Recebendo o valor do caseId
      caseId = digitalContact.caseId;
      this.logger.info(
        'CIVICS - ContactId do evento digital recebido: ',
        caseId,
      );

      const ujson = await this.mainService.generatePopUrlFronDigitalContact(
        digitalContact,
        'CIVICS',
      );

      if (!ujson) {
        this.logger.warn(
          'CIVICS - Dados não obtidos da extração do digitalEvent.',
        );
        isPopUrl = true;
      } else {
        popUrl = ujson.popUrl;
        channel = ujson.channel;
      }

      //Obtendo o Object Channel Providers Variables
      await this.mainService
        .loadTemplateValues(channel)
        .then((obj) => {
          this.channelProviderVariablesObj = obj;

          if (!obj) {
            this.logger.error(
              'CIVICS - Channel provider nulo, ',
              JSON.stringify(obj, null, 2),
            );
          }

          this.logger.info(
            'CIVICS - Channel provider variables object: ',
            JSON.stringify(obj, null, 2),
          );
        })
        .catch((error) => {
          this.logger.error(
            'CIVICS - Erro ao carregar o object channel provider variables, ',
            error,
          );
        });

      if (isPopUrl) {
        popUrl = await this.handleFallbackPopUrl(digitalContact.caseId);
      }

      this.logger.info(
        'CIVICS - Iniciando a criação do ticket, ',
        JSON.stringify(popUrl),
      );

      await this.DigitalContactCaseAssignedHandler(
        popUrl,
        isPopUrl,
        caseId,
        getMediaType(digitalContact),
      );
    } catch (error) {
      this.logger.error(
        '- CIVICS - Erro ao processar contato de digital: ',
        error,
      );
    }
  }

  private async processDigitalEndedEvent(digitalEvent: CXoneDigitalContact) {
    const sessionRelationship = this.localStorageUtils.safeGetItem(
      `sessionRelationship-${digitalEvent.caseId}`,
    );

    this.logger.info(
      'CIVICS - Evento de encerramento recebebido: ',
      JSON.stringify(sessionRelationship),
    );

    const templateEnded = this.sessionEnded.find(
      (e) => e.contactId === digitalEvent.caseId,
    );

    this.logger.info(
      'CIVICS - Parametros de encerramento de ticket: ',
      JSON.stringify(templateEnded),
    );
    this.logger.info(
      'CIVICS - Template de encerramento: ',
      templateEnded?.templateAusente,
    );

    //remover contactId do array
    this.logger.info(
      'CIVICS - Remover da lista o contactId: ',
      digitalEvent.caseId,
    );
    this.activeSessionsIds = this.activeSessionsIds.filter(
      (id) => id !== digitalEvent.caseId,
    );

    if (sessionRelationship != null) {
      let sessionRelationshipJSON =
        this.jsonConverterUtils.JsonParsed(sessionRelationship);
      const sessionId = sessionRelationshipJSON.dynamicsSessionId;

      const context = {
        itau_cliente_on: false,
        itau_sessao_ativa: false,
      };

      this.logger.info('CIVICS - Encerrando sessão', sessionId);

      try {
        const updateResult = await (
          window as any
        ).Microsoft.CIFramework.updateContext(context, sessionId);

        const input = {
          templateName: templateEnded?.templateAusente,
          templateParameters: {},
        };

        const idInteracao = updateResult?.id_interacao;

        if (!sessionId || !idInteracao) {
          this.logger.warn(
            'CIVICS - sessionId ou idInteracao ausentes, não é possível fechar a sessão.',
          );
          return;
        }

        await (window as any).Microsoft.CIFramework.notifyEvent(input);

        // Chama a função para motivar o encerramento com o id da interação
        const eventInputParameters = {
          sessionId: sessionId,
          correlationId: idInteracao,
        };

        await (window as any).Microsoft.CIFramework.raiseEvent(
          'fecharSessao',
          eventInputParameters,
        );

        //Limpar o item do array após o encerramento da sessão
        this.logger.info(
          'CIVICS - Remover template de encerramento da lista: ',
          JSON.stringify(templateEnded),
        );
        this.logger.info(
          'CIVICS - Resultado antes da remoção: ',
          JSON.stringify(this.sessionEnded),
        );
        this.sessionEnded = this.sessionEnded.filter(
          (id) => id.contactId !== digitalEvent.caseId,
        );
        this.logger.info(
          'CIVICS - Resultado após a remoção: ',
          JSON.stringify(this.sessionEnded),
        );

        this.logger.info('CIVICS - sessão fechada com sucesso', sessionId);
      } catch (error) {
        this.logger.error(
          'CIVICS - Erro ao fechar sessão: ',
          error,
          'sessionId:',
          sessionId,
        );
        throw error;
      }
    }
  }

  private async DigitalContactCaseAssignedHandler(
    popUrl: any,
    isPopUrl: boolean,
    masterId: string,
    mediaType: MediaType,
  ) {
    let attachdata: any = {};
    let contactId = '';

    if (isPopUrl === true) {
      attachdata = this.deserializeScreenPopUrl(popUrl);
      contactId = popUrl.caseId;
    } else {
      const popUrlData = JSON.stringify(popUrl);
      attachdata = this.jsonConverterUtils.JsonParsed(popUrlData);
      contactId = attachdata['contactId'];
    }

    this.logger.info(
      `CIVICS - attachdata deserializado: ${JSON.stringify(attachdata)}`,
    );

    //Inserindo template ausente para encerramento da sessão digital
    this.sessionEnded.push({
      contactId: contactId,
      templateAusente:
        this.channelProviderVariablesObj?.templateAusente ??
        attachdata.templateausente,
    });
    this.logger.info(
      'CIVICS - Sessão de encerramento armazenada: ',
      this.sessionEnded,
    );

    //Inserindo contactId no array utilizado para alternância de abas, somente CIVICS
    this.logger.info('CIVICS - Inserir no array contactId: ', contactId);
    this.activeSessionsIds.push(contactId);
    this.logger.info(
      'CIVICS - ContactId Inseridos no array : ',
      this.activeSessionsIds,
    );

    const ticketHasRequest =
      this.ticketCreationRequestControlService.checkTicketRequest(contactId);

    if (ticketHasRequest === true) {
      this.logger.warn(
        `CIVICS - Já existe ticket aberto com os dados solicitados, ${contactId}`,
      );
      this.cifDatadogService.openTicket.request.duplicated({
        masterId: masterId,
        attachData: attachdata,
        mediaType,
      });
      return;
    }

    this.ticketCreationRequestControlService.saveTicketRequest(contactId);

    var datacb: any = {};
    datacb['itau_name'] =
      this.channelProviderVariablesObj?.itau_name ?? attachdata.itau_name;
    datacb['itau_mst_attachdata'] =
      isPopUrl === false
        ? JSON.stringify(attachdata['u_json'])
        : JSON.stringify(attachdata.u_json);
    datacb['itau_u_lk_projeto@odata.bind'] =
      this.channelProviderVariablesObj?.itau_u_lk ?? attachdata.itau_u_lk;
    datacb['itau_u_nomeprojeto'] =
      this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
      attachdata.itau_u_nomeprojeto;
    datacb['itau_st_id_conexao'] = contactId;
    datacb[
      this.channelProviderVariablesObj?.fieldNegocio ?? attachdata.fieldNegocio
    ] = this.channelProviderVariablesObj?.itau_name ?? attachdata.itau_name;
    // datacb[this.channelProviderVariables?.triggerPlugin ?? ''] =
    //   attachdata.itau_u_nomeprojeto;

    this.logger.info(
      'CIVICS - Dados do ticket a serem criados: ',
      JSON.stringify(datacb),
    );

    const result = await this.dynamics.cifCreateTicket(
      datacb,
      contactId,
      mediaType,
      attachdata.u_json,
    );

    if (!result || !result.id_interacao || !result.id_ticket) {
      this.logger.error(
        `CIVICS - Erro ao criar ticket: ${JSON.stringify(result)}`,
      );
      return;
    }

    var input: any = {};
    input['templateName'] = this.channelProviderVariablesObj
      ?.templateCreateSession
      ? this.channelProviderVariables?.templateCreateSession
      : attachdata.templateCreateSession;
    input['templateParameters'] = {
      id_interacao: result.id_interacao,
      id_ticket: result.id_ticket,
      cliente_on: true,
    };
    input['isFocused'] = this.activeSessionsIds.length > 1 ? false : true; //Se for a primeira interação ele força o focus da aba, se for a partir da segunda interação ele não força o focus da aba.

    this.logger.info(`CIVICS - Criando sessão: ${JSON.stringify(input)}`);

    const sessionId = await this.dynamics.cifCreateSession(
      input,
      mediaType,
      masterId,
    );

    var sessionData: any = {};
    sessionData['contactCenterInteractionId'] = popUrl.contactId;
    sessionData['dynamicsSessionId'] = sessionId;
    sessionData['dynamicsinteractionId'] = result.id_interacao;
    sessionData['dynamicsTicketId'] = result.id_ticket;

    this.localStorageUtils.safeSetItem(
      `sessionRelationship-${sessionData.contactCenterInteractionId}`,
      JSON.stringify(sessionData),
    );

    //Se já tiver uma aba aberta no dynamics, o método insere uma marcação na nova aba para informar ao operador que chegou uma nova interação.
    if (this.activeSessionsIds.length > 1) {
      await (window as any).Microsoft.CIFramework.requestFocusSession(
        sessionId,
        result.id_interacao,
      );
    }

    this.logger.info('CIVICS - Fluxo de ticket executado com sucesso', result);
  }

  /** ##### FIM MÉTODOS DE PROCESSAMENTO DO DIGITAL CIVICS ##### **/

  private async processVoiceContactEvent(
    voiceContact: CXoneVoiceContact,
    logStringAgent: string,
  ): Promise<void> {
    try {
      if (typeof (window as any).Microsoft !== 'undefined') {
        const attachdata = this.deserializeScreenPopUrl(
          voiceContact.screenPopUrl,
        );

        this.logger.info(
          `CIVICS (ACD - ${logStringAgent}) - attachdata deserializado: ${JSON.stringify(attachdata)}`,
        );

        if (!voiceContact.isInbound && !attachdata.callback) {
          this.logger.info(
            `CIVICS (ACD - ${logStringAgent}) - Contato não é inbound, não executando a criação de ticket no dynamics`,
          );
          return;
        }

        var datacb: any = {};
        datacb['itau_name'] = attachdata.itau_name;
        datacb['itau_mst_attachdata'] = JSON.stringify(attachdata.u_json);
        datacb['itau_u_lk_projeto@odata.bind'] = attachdata.itau_u_lk;
        datacb['itau_u_nomeprojeto'] = attachdata.itau_u_nomeprojeto;
        datacb['itau_st_id_conexao'] = voiceContact.contactID;
        datacb[this.channelProviderVariables?.fieldNegocio ?? ''] =
          attachdata.itau_name;
        datacb[this.channelProviderVariables?.triggerPlugin ?? ''] =
          attachdata.itau_u_nomeprojeto;

        this.logger.info(
          `CIVICS (ACD - ${logStringAgent}) - Dados do ticket a serem criados: ${JSON.stringify(datacb)}`,
        );

        // faz a criação do ticket
        const result = await this.dynamics.cifCreateTicket(
          datacb,
          voiceContact.contactID,
          'voice',
          attachdata.u_json,
        );

        if (!result || !result.id_interacao || !result.id_ticket) {
          this.logger.error(
            `CIVICS (ACD - ${logStringAgent}) - Erro ao criar ticket: ${JSON.stringify(result)}`,
          );
          return;
        }

        let input_atendimento = {
          templateName: this.channelProviderVariables?.templateCreateSession,
          templateParameters: {
            id_interacao: result.id_interacao,
            id_ticket: result.id_ticket,
          },
        };
        this.logger.info(
          `CIVICS (ACD - ${logStringAgent}) - Criando sessão: ${JSON.stringify(input_atendimento)}`,
        );

        // abre uma aba com o ticket que foi aberto e salva o sessionId no localStorage
        const sessionId = await this.dynamics.cifCreateSession(
          input_atendimento,
          getMediaType(voiceContact),
          voiceContact.contactID,
        );
        this.localStorageUtils.safeSetItem(voiceContact.contactID, sessionId);
        this.localStorageUtils.safeSetItem(sessionId, voiceContact.contactID);

        this.sendReloadScreenSignalService.setInteractionIdInLocalStorage(
          voiceContact.contactID,
        );

        this.logger.info(
          `CIVICS (ACD - ${logStringAgent}) - função de criação de ticket executada com sucesso: ${JSON.stringify(result)}`,
        );
      } else {
        this.logger.warn(
          'Função microsoft.Microsoft.Cif ainda não está disponível.',
        );
      }
    } catch (error) {
      this.eventHandler.remove({ id: voiceContact.contactID, status: '' });
      this.logger.error(
        `CIVICS (ACD - ${logStringAgent}) - Erro ao processar contato de voz: ${error}`,
      );
    }
  }

  //Aguardar para rechamar
  async aguardarRechamada(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async getWebRtcServiceUrls() {
    const agentSettings =
      (await CXoneClient.instance.agentSetting.getAgentSettings()) as AgentSettings;
    const getUserInfo =
      (await CXoneClient.instance.cxoneUser.getUserDetails()) as UserInfo;
    if (!agentSettings && getUserInfo.icAgentId) {
      return;
    }

    return {
      agentId: getUserInfo.icAgentId,
      agentSettings: agentSettings,
      userInfo: getUserInfo,
    };
  }

  deserializeScreenPopUrl(screenPopUrl: string) {
    const objeto: any = {};

    // prettier-ignore
    screenPopUrl = screenPopUrl.replaceAll("'", "\"");

    const pares = screenPopUrl.split('|');

    pares.forEach((par) => {
      const idx = par.indexOf(':');
      if (idx > -1) {
        const chave = par.substring(0, idx);
        const valor = par.substring(idx + 1);
        if (chave) {
          try {
            objeto[chave.toLowerCase()] = JSON.parse(valor);
          } catch (e) {
            objeto[chave.toLowerCase()] = valor;
          }
        }
      }
    });

    return objeto;
  }

  private async handleFallbackPopUrl(caseId: string) {
    let popUrl = '';

    this.logger.info('CIVICS - Iniciando busca pelo evento de popUrl');

    for (let tentativa = 1; tentativa <= 10; tentativa++) {
      this.logger.info(`CIVICS - Tentativa ${tentativa} de 10.`);

      popUrl = this.pendingPopUrls.get(caseId)?.url ?? '';

      if (popUrl) {
        this.logger.info('CIVICS - PopUrl encontrado:', caseId);
        break;
      }

      this.logger.warn('CIVICS - PopUrl não encontrado:', caseId);

      await CxOneUtils.Delay(1000);
    }

    return popUrl;
  }

  async initWebRTC() {
    try {
      const agentSettings = (await this.getWebRtcServiceUrls()) as {
        agentId: string;
        agentSettings: AgentSettings;
        userInfo: UserInfo;
      };

      const app = 'Nice CXone SDK Consumer';
      const appName = `${(app || 'cxa').toUpperCase()}: ${agentSettings?.agentSettings.cxaClientVersion}`;
      CXoneVoiceClient.instance.connectServer(
        agentSettings?.agentId,
        agentSettings?.agentSettings,
        new Audio('<audio ref={audio_tag} id="audio" controls autoPlay/>'),
        appName,
      );
      this.logger.info('Connected to WebRTC');
    } catch (e) {
      this.logger.error(`Error initializing WebRTC: ${e}`);
    }
  }
}
